
/**
 * \@docs-private
 */
export class AnimationCurves {
  static STANDARD_CURVE = 'cubic-bezier(0.4,0.0,0.2,1)';
  static DECELERATION_CURVE = 'cubic-bezier(0.0,0.0,0.2,1)';
  static ACCELERATION_CURVE = 'cubic-bezier(0.4,0.0,1,1)';
  static SHARP_CURVE = 'cubic-bezier(0.4,0.0,0.6,1)';
}

function AnimationCurves_tsickle_Closure_declarations() {
/** @type {?} */
AnimationCurves.STANDARD_CURVE;
/** @type {?} */
AnimationCurves.DECELERATION_CURVE;
/** @type {?} */
AnimationCurves.ACCELERATION_CURVE;
/** @type {?} */
AnimationCurves.SHARP_CURVE;
}

/**
 * \@docs-private
 */
export class AnimationDurations {
  static COMPLEX = '375ms';
  static ENTERING = '225ms';
  static EXITING = '195ms';
}

function AnimationDurations_tsickle_Closure_declarations() {
/** @type {?} */
AnimationDurations.COMPLEX;
/** @type {?} */
AnimationDurations.ENTERING;
/** @type {?} */
AnimationDurations.EXITING;
}

